import { NavLink } from 'react-router-dom';
import './index.css';

// Minimal top nav for the events / ticketing pages. Styled to match the
// app's brand-blue surface and pill controls.
export default function NavBar() {
  return (
    <header className='navbar'>
      <NavLink to='/' className='navbar-brand'>MP3JUUG</NavLink>
      <nav className='navbar-tabs' aria-label='Sections'>
        <NavLink
          to='/events'
          className={({ isActive }) => `navbar-tab${isActive ? ' navbar-tab-active' : ''}`}
        >
          Events
        </NavLink>
        <NavLink
          to='/media'
          className={({ isActive }) => `navbar-tab${isActive ? ' navbar-tab-active' : ''}`}
        >
          Cop JUUGs
        </NavLink>
      </nav>
    </header>
  );
}
